module.exports = __webpack_public_path__ + "static/bolca-0f1cb3b26a70b05919e4971bdb1b87f4.jpeg";